import * as React from "react";
import { NewModal } from "../uiMerge/newModal";
import NewButton from "../uiMerge/newButton";
import TermsAndConditionsModal from "./termsAndConditionsModal";
import { pointsValue } from "@njoy/common";

/** Paying part of a paid offer with points: what the member can use. */
export type PointsOption = {
  maxPoints: number;
  pointValue: number;
  price: number;
  points: number;
  onChange: (points: number) => void;
};

type OfferConfirmationModalProps = {
  visible: boolean;
  onCancel: () => void;
  isSubmitting?: boolean;
  onClick?: () => void;
  offerName: string;
  offerTOR: string;
  pointsOption?: PointsOption;
};

const naira = (amount: number) => `₦${amount.toLocaleString("en-NG", { maximumFractionDigits: 2 })}`;

const PointsPicker: React.FC<{ option: PointsOption }> = ({ option }) => {
  const { maxPoints, pointValue, price, points, onChange } = option;
  const off = pointsValue(points, pointValue);
  return (
    <div className="w-full rounded-lg bg-[#1E1E1E] p-3 text-white text-[13px]">
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={points > 0}
          onChange={(e) => onChange(e.target.checked ? maxPoints : 0)}
        />
        Use points (up to {maxPoints.toLocaleString("en-NG")})
      </label>
      {points > 0 && (
        <>
          <input
            type="range"
            className="w-full mt-2"
            min={1}
            max={maxPoints}
            value={points}
            onChange={(e) => onChange(Number(e.target.value))}
            aria-label="Points to use"
          />
          <p className="mt-1 text-[#CECECF]">
            {points.toLocaleString("en-NG")} points = {naira(off)} off. You pay {naira(price - off)}.
          </p>
        </>
      )}
    </div>
  );
};
const OfferConfirmationModal: React.FC<OfferConfirmationModalProps> = ({
  visible,
  onCancel,
  onClick,
  isSubmitting,
  offerName,
  offerTOR,
  pointsOption
}) => {
  const [offerTermModalVisible, setOfferTermModalVisible] =
    React.useState(false);

  const handleOfferTermCancel = () => setOfferTermModalVisible(false);

  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-[10px]"
      colorClass="bg-black"
      widthClass="w-[335px]"
      position="center"
      onClose={onCancel}
    >
      <div className={`flex ${pointsOption ? "min-h-[290px] pb-6" : "h-[290px]"} justify-center`}>
        <div className="flex flex-col items-center justify-center mt-6 py-[2px] gap-3 w-[275px]">
          <p className="font-extrabold text-center text-white text-[20px]">
            Are you sure you want to redeem this offer?
          </p>
          <p
            onClick={() => setOfferTermModalVisible(true)}
            className="text-[color:var(--brand-primary)] text-[12px] cursor-pointer text-center"
          >
            Terms & Conditions Apply
          </p>

          {pointsOption && <PointsPicker option={pointsOption} />}

          <div className="flex gap-4 items-center  mt-6 w-full">
            <NewButton fullWidth onClick={onCancel} variant="outline">
              Cancel
            </NewButton>

            {/* <NewButton
              fullWidth
              onClick={onClick}
              //   type="submit"
              type="button"
              disabled={isSubmitting}
            >
              Redeem
            </NewButton> */}

            <NewButton fullWidth onClick={onClick} disabled={isSubmitting}>
              Redeem
            </NewButton>
          </div>
        </div>
      </div>
      <TermsAndConditionsModal
        visible={offerTermModalVisible}
        onCancel={handleOfferTermCancel}
        offerName={offerName}
        offerTOR={offerTOR}
      />
    </NewModal>
  );
};

export default OfferConfirmationModal;
